($('a[data-toggle=modal]')).on('click', function() {
  const link = $(this);
  const href = link.attr('href');

  if (!href || href.charAt(0) === '#') {
    return;
  }

  const target = $(link.data('target'));

  if (target.length === 0) {
    return;
  }

  $.get(href, (data) => {
    target.html(data);
    target.modal('show');
  });
});
